/**
 * Include this mixin in all components used in Form to allow for a common interface.
 *
 * IMPORTANT: This mixin relies on "field" ref to be present in your component.
 */
import propsFieldValidator from '@/components/_shared/Form/Validation/props-field-validator'

export default {
  props: {
    ...propsFieldValidator,
  },

  methods: {
    getFieldRef() {
      return this.$refs.field
    },

    getFieldEl() {
      return this.getFieldRef()?.getFieldEl()
    },

    getIsValid() {
      return this.getFieldRef()?.getIsValid()
    },

    getHasError() {
      return this.getFieldRef()?.getHasError()
    },

    focus() {
      this.getFieldRef()?.focus()
    },

    validate() {
      this.getFieldRef()?.validate()
    },

    setOneTimeErrorMessage(errorMessage) {
      this.getFieldRef()?.setOneTimeErrorMessage(errorMessage)
    },
  },
}
